module.exports = __webpack_public_path__ + "img/devante_parker.8022187e.png";